import React from 'react';
import {
  Box,
  GDSStyleObject,
  ParagraphText,
  Card,
  HeadingText,
  StackLayout,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { HtmlToReact } from '@leagueplatform/web-common';

export function EasyPlanContainerComponent(props: any) {
  const { children, description, title, image, dataTestId } = props;
  const isHeight786 = useMediaQuery('(max-height:786px)');

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          backgroundColor: 'White',
          maxWidth: '476px',
          width: '476px',
          height: 'max-content',
          overflowX: 'hidden',
          minHeight: '586px',
          marginTop: '$oneAndhalf',
          borderRadius: '9px 9px 0 0',
          '@mobile': {
            height: isHeight786 ? 'max-content' : 'max-content',
            width: 'auto',
            marginTop: '0',
          },
          '@desktop': {
            minHeight: '670px',
          },
          '@laptop': {
            minHeight: '670px',
          },
        } as GDSStyleObject
      }
      data-testid={dataTestId}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$none $none',
            marginTop: '-8px',
          } as GDSStyleObject
        }
      >
        <Card.Flat
          css={{
            height: 'auto',
            minHeight: '176px',
            border: '0px solid',
            top: '20px',
            '@mobile': {
              maxHeight: '100vh',
            },
            '@desktop': {
              width: '176px',
              maxHeight: '176px',
              marginTop: '$four',
            },
            '@laptop': { width: '176px', marginTop: '$four' },
            '@mobileLandscape': { width: '176px' },
            '@tablet': { width: '176px' },
          }}
        >
          <Card.Image
            image={image}
            imageAlt="easy header"
            css={{ maxWidth: '176px', height: '176px' }}
          />
        </Card.Flat>
        <Box
          css={
            {
              margin: '$two $none $one $none',
              width: '327px',
              textAlign: 'center',
            } as GDSStyleObject
          }
        >
          <HeadingText
            size="md"
            level="2"
            css={
              {
                fontSize: '$headingTwo',
                marginLeft: '0px',
                lineHeight: '33px',
              } as GDSStyleObject
            }
          >
            {title}
          </HeadingText>
          <Box css={{ width: '327px' }}>
            <ParagraphText
              css={{
                marginTop: '$half',
                fontSize: '$bodyOne',
                lineHeight: '$subtitleOne',
              }}
              emphasis="subtle"
              size="base"
            >
              <HtmlToReact htmlString={description} />
            </ParagraphText>
          </Box>
        </Box>
      </Box>
      {children}
    </StackLayout>
  );
}
